<script setup lang="ts">
import TrendingProducts from '~/components/homepage/TrendingProducts.vue';
</script>
<template>
	<ClientOnly>
		<TrendingProducts
			no-title
			:node-id="[1, 21, 41, 54]"
			route-name="all-products"
		/>
	</ClientOnly>
</template>
